import { styled, Flex } from "@acko-tech/building-blocks.ui.common";
import { ButtonText } from "@acko-tech/building-blocks.ui.button-old";

export const EditContainer = styled(Flex)`
  width: max-content;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  :hover {
    cursor: pointer;
  }
`;

export const Hyperlink = styled(ButtonText)`
  font-weight: 500;
  font-size: 14px
  line-height: 20px;
  color: #1b73e8;
  width: max-content;
  display: inline-block;
  ${(props) => props.styles};
`;
